import React, { useContext, lazy } from "react";
import { Route, Switch, Redirect, useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthProvider";
import { RoutesUser, RoutesGuest } from "./index";

// backward compatibility for existing shared links so they work with
// header widget & query params
const RedirectTrackToBrowse = () => {
  const { id } = useParams();
  return <Redirect to={`/browse?trackId=${id}`} />;
};

const RedirectAlbumToBrowse = () => {
  const { id } = useParams();
  return <Redirect to={`/browse?albumId=${id}`} />;
};

const BrowseContainer = lazy(() =>
  import("../../pages/Shared/Browse/BrowseContainer")
);
const Landing = lazy(() => import("../../pages/Shared/Landings/1"));
const Checkout = lazy(() => import("../../pages/Shared/Checkout"));
const PlaylistContainer = lazy(() =>
  import("../../pages/Shared/Playlists/PlaylistsContainer")
);
const OrderConfirmationContainer = lazy(() =>
  import("../../pages/Shared/OrderConfirmation")
);

const PlaylistRedirect = () => {
  const { id } = useParams();
  return <Redirect to={`/browse?playlistId=${id}`} />;
};

/*
 * Add all routes specific to the main app here
 *
 * NB: this also handles different routing depending on user authentication
 * e.g., redirects if not logged in, etc.
 */
const RoutesMain = () => {
  const { user } = useContext(AuthContext);

  return (
    <Switch>
      <Route exact path="/" component={BrowseContainer} />
      <Route exact path="/landing" component={Landing} />
      <Route exact path="/browse" component={BrowseContainer} />
      <Route exact path="/browse/track/:id" component={RedirectTrackToBrowse} />
      <Route exact path="/order" component={Checkout} />
      <Route exact path="/order/:orderId" component={Checkout} />
      <Route exact path="/subscription" component={Checkout} />
      <Route exact path="/subscription/:subscriptionId" component={Checkout} />
      <Route exact path="/playlists" component={PlaylistContainer} />
      <Route exact path="/playlist/:id" component={PlaylistRedirect} />
      <Route exact path="/album/:id" component={RedirectAlbumToBrowse} />
      <Route
        exact
        path="/order-confirmation/:id"
        component={OrderConfirmationContainer}
      />
      {/* ! private vs public route injection must be last route entry */}
      {user.role === "private" ? <RoutesUser /> : <RoutesGuest />}
    </Switch>
  );
};

export default RoutesMain;
